//buy now
$(document).ready(function() { $(".shopify-payment-button__button--unbranded").text("Buy Now"); }); 


//review scroll
document.addEventListener("DOMContentLoaded", function () {
    var jdgmWidget = document.querySelector(".jdgm-widget");

    if (jdgmWidget) {
        jdgmWidget.addEventListener("click", function (e) {
            e.preventDefault();

            var reviewSection = document.getElementById("judgeme_product_reviews");

            if (reviewSection) {
                reviewSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    }
});

// stickycart


document.addEventListener("click", function () {
  setTimeout(function () {

    var errorMessage = document.querySelector(".product-form__error-message-wrapper");

    if (errorMessage && errorMessage.offsetParent !== null) {
      errorMessage.style.transition = "opacity 0.4s ease";
      errorMessage.style.opacity = "0";

      setTimeout(function () {
        errorMessage.style.display = "none";
        errorMessage.style.opacity = "1";
      }, 400);
    }

  }, 6000);

});



//header megamenu
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("details.mega-menu").forEach(details => {
    const summary = details.querySelector("summary");
    let timeout;
    details.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      details.open = true;
      if (summary) summary.setAttribute("aria-expanded", "true");
    });
    details.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        details.open = false;
        if (summary) summary.setAttribute("aria-expanded", "false");
      }, 300); 
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const detailsMenus = document.querySelectorAll('header nav details');
  detailsMenus.forEach(function (menu) {
    menu.addEventListener("mouseenter", function () {
      if (window.innerWidth > 990) { 
        menu.setAttribute("open", "");
        const summary = menu.querySelector("summary");
        if (summary) {
          summary.setAttribute("aria-expanded", "true");
        }
      }
    });
    menu.addEventListener("mouseleave", function () {
      if (window.innerWidth > 990) {
        menu.removeAttribute("open");
        const summary = menu.querySelector("summary");
        if (summary) {
          summary.setAttribute("aria-expanded", "false");
        }
      }
    });
  });
});




// capture title immediately when page loads
document.addEventListener("DOMContentLoaded", function(){
  swymProductTitle =
    document.querySelector('.product__title h1, h1')?.innerText || "";
});

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function(swym) {

  swym.evtLayer.addEventListener('sw:addedtowishlist', function(e) {

    let titleFromUrl = null;
    const du = e?.detail?.d?.du || e?.detail?.du || "";

    if (du && du.includes("/products/")) {
      const handle = du.split("/products/")[1].split("?")[0];

      // convert handle -> title
      titleFromUrl = handle
        .replace(/-/g, " ")
        .replace(/\b\w/g, l => l.toUpperCase()); // lokiapad -> Lokiapad
    }

    // Step 1: Resolve title from multiple sources
    const productTitle =
      e?.detail?.dt ||
      e?.detail?.title ||
      e?.detail?.name ||
      titleFromUrl ||
      document.querySelector('.product__title')?.textContent?.trim() ||
      null;

    if (!productTitle) {
      return;
    }

    // Step 2: Wait for Swym notification render
    let attempts = 0;
    const maxAttempts = 50;

    const interval = setInterval(function() {
      attempts++;

      const titleEl = document.querySelector(
        '#swym-storefront-layout-notification .swym-storefront-layout-notification-title'
      );

      console.log(`Attempt ${attempts} - titleEl:`, titleEl);

      if (titleEl) {
        titleEl.textContent = productTitle;
        clearInterval(interval);
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }

    }, 100);

  });

});




setTimeout(function() {
  var dates = document.querySelectorAll(
    'p.jm-text[style*="--jm-body-sm-size"]'
  );
  var today = new Date();
  var customDays = [10, 20, 5, 4, 18, 25, 12, 8, 16, 22];
  for (var i = 0; i < dates.length; i++) {
    var newDate = new Date();
    newDate.setMonth(today.getMonth() - i);
    var month = ("0" + (newDate.getMonth() + 1)).slice(-2);
    var day = ("0" + customDays[i % customDays.length]).slice(-2);
    var year = newDate.getFullYear();
    dates[i].textContent = month + "/" + day + "/" + year;
  }
}, 2000);

